import Filter from '@mui/icons-material/FilterList';
import { Box } from '@ovComponents/1-primative/box/box';
import { Button } from '@ovComponents/2-component/button/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from '@ovComponents/2-component/dialog/dialog';
import { IconButton } from '@ovComponents/2-component/iconButton/iconButton';
import { useThemeTokens } from '@providers/themeTokenProvider';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const FilterModal = ({
  children,
  filterExists,
  sx = {},
  title,
  onConfirm,
  onClose,
  onClearAll,
  disabled,
  testIds,
}: {
  children: any;
  filterExists?: boolean;
  sx?: any;
  title?: string;
  onConfirm?: () => void;
  onClose?: () => void;
  onClearAll?: () => void;
  disabled?: boolean;
  testIds?: {
    dialogOpenButton?: string;
    dialogSubmitButton?: string;
    dialogCloseButton?: string;
  };
}) => {
  const { t } = useTranslation(['components', 'shared']);
  const [open, setOpen] = useState(false);
  const { sys } = useThemeTokens();

  const onCloseClick = () => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };
  const onConfirmClick = () => {
    setOpen(false);
    if (onConfirm) {
      onConfirm();
    }
  };
  const onClearAllClick = () => {
    setOpen(false);
    if (onClearAll) {
      onClearAll();
    }
  };

  return (
    <>
      <Box position='relative' sx={sx}>
        <IconButton
          onClick={() => setOpen(true)}
          label={t('filter')}
          data-testid={testIds?.dialogOpenButton}
        >
          <Filter />
        </IconButton>
        {filterExists && (
          <Box
            sx={{
              position: 'absolute',
              top: '8px',
              right: '8px',
              height: '8px',
              width: '8px',
              borderRadius: '50%',
              backgroundColor: sys.color.negative,
            }}
          />
        )}
      </Box>
      <Dialog open={open} onClose={onCloseClick} fullWidth maxWidth='xs'>
        <DialogTitle
          testIds={{ dialogCloseButton: testIds?.dialogCloseButton }}
          onClose={onCloseClick}
        >
          {title ?? t('filter')}
        </DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogFooter>
          {!!onClearAll && (
            <Box display='flex' justifyContent='flex-end'>
              <Button
                variant='tonal'
                label={t('shared:clearAll')}
                onClick={onClearAllClick}
                sx={{ mr: 1 }}
                disabled={!filterExists}
              />
            </Box>
          )}
          <Box display='flex' justifyContent='flex-end'>
            <Button
              disabled={disabled}
              label={t('shared:done')}
              onClick={onConfirmClick}
              dataTestId={testIds?.dialogSubmitButton}
            />
          </Box>
        </DialogFooter>
      </Dialog>
    </>
  );
};
